"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTrendFromRounds = exports.summaryAverage = exports.RoundValidator = exports.RoundStateValues = exports.RoundState = void 0;
const util_1 = require("../util");
var RoundState;
(function (RoundState) {
    RoundState["Created"] = "created";
    RoundState["SelectEmployee"] = "employee";
    RoundState["SelectManager"] = "manager";
    RoundState["Active"] = "active";
    RoundState["Completed"] = "completed";
})(RoundState = exports.RoundState || (exports.RoundState = {}));
exports.RoundStateValues = [
    RoundState.Created,
    RoundState.SelectEmployee,
    RoundState.SelectManager,
    RoundState.Active,
    RoundState.Completed,
];
exports.RoundValidator = util_1.generateValidator('Round');
function average(arr) {
    if (arr.length)
        return arr.reduce((acc, cur) => acc + cur, 0) / arr.length;
    return 0;
}
function summaryAverage(summary) {
    const { version, ...rest } = summary;
    return average(Object.values(rest));
}
exports.summaryAverage = summaryAverage;
function calculateTrendFromRounds(rounds) {
    const ret = {
        positive: false,
        delta: 0,
        toLow: false,
    };
    const averages = rounds.filter((round) => round.summary).map((round) => summaryAverage(round.summary));
    const threshold = 0.85;
    switch (averages.length) {
        case 0:
            break;
        case 1:
            ret.toLow = averages[0] < threshold;
            ret.positive = !ret.toLow;
            break;
        default: {
            ret.delta = averages[0] - averages[1];
            if (averages[0] < threshold) {
                ret.positive = false;
                ret.toLow = true;
            }
            else {
                ret.positive = ret.delta > -0.05;
            }
            break;
        }
    }
    ret.delta *= 100;
    return ret;
}
exports.calculateTrendFromRounds = calculateTrendFromRounds;
//# sourceMappingURL=round.js.map